import { render, staticRenderFns } from "./AddGoods.vue?vue&type=template&id=244325bf&scoped=true&"
import script from "./AddGoods.vue?vue&type=script&lang=ts&"
export * from "./AddGoods.vue?vue&type=script&lang=ts&"
import style0 from "./AddGoods.vue?vue&type=style&index=0&id=244325bf&lang=less&scoped=true&"
import style1 from "./AddGoods.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "244325bf",
  null
  
)

export default component.exports